export default __webpack_public_path__ + "static/media/phonics.c1e57ce5.svg";